import { render, staticRenderFns } from "./editLog.vue?vue&type=template&id=65bf634e&scoped=true&"
import script from "./editLog.vue?vue&type=script&lang=js&"
export * from "./editLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf634e",
  null
  
)

export default component.exports